import { render, staticRenderFns } from "./role_edit.vue?vue&type=template&id=03daa58e&scoped=true&"
import script from "./role_edit.vue?vue&type=script&lang=js&"
export * from "./role_edit.vue?vue&type=script&lang=js&"
import style0 from "./role_edit.vue?vue&type=style&index=0&id=03daa58e&prod&scoped=true&lang=css&"
import style1 from "./role_edit.vue?vue&type=style&index=1&id=03daa58e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03daa58e",
  null
  
)

export default component.exports